import React from 'react'

export type OmnibarContextState = {
    isOpen: boolean
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}
export const OmnibarContext = React.createContext({} as OmnibarContextState)
export const useOmnibarContext = () => React.useContext(OmnibarContext)
